(function () {
  'use strict';

  if (window.__kkMysterySetAtcInitialized) {
    return;
  }

  window.__kkMysterySetAtcInitialized = true;

  var TARGET_PRODUCT_ID = '8085565898982';
  var BUTTON_SELECTOR = '[data-kk-mystery-set-atc]';
  var pendingForms = new WeakSet();
  var touchActivation = null;
  var lastTouchActivationAt = 0;

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function getRoute(routeName, fallback) {
    var themeRoutes = window.Theme && window.Theme.routes;
    var route = themeRoutes && themeRoutes[routeName];

    if (!route) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      route = String(root || '/').replace(/\/$/, '') + '/' + fallback;
    }

    return String(route).replace(/\.js(?:\?.*)?$/, '') + '.js';
  }

  function getProductForm(button) {
    var form = button && button.closest('form[data-product-form]');
    var productId = form && form.querySelector('[name="product-id"]');

    if (!form || !productId || String(productId.value) !== TARGET_PRODUCT_ID) {
      return null;
    }

    return form;
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = parseInt(quantityInput ? quantityInput.value : '', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getProperties(form) {
    var properties = {};

    toArray(form.querySelectorAll('[name^="properties["]')).forEach(function (field) {
      var match = field.name && field.name.match(/^properties\[(.+)\]$/);

      if (!match || match[1].charAt(0) === '_') {
        return;
      }

      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
        return;
      }

      var value = String(field.value || '').trim();

      if (value) {
        properties[match[1]] = value;
      }
    });

    return properties;
  }

  function getStatus(form, button) {
    var status = form.querySelector('[data-kk-mystery-set-atc-error]');

    if (!status) {
      status = document.createElement('p');
      status.className = 'kk-mystery-set-atc-error';
      status.setAttribute('data-kk-mystery-set-atc-error', '');
      status.setAttribute('role', 'alert');
      status.hidden = true;
      (button.parentElement || form).insertAdjacentElement('afterend', status);
    }

    return status;
  }

  function updateHeaderCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') {
      return;
    }

    var visibleCount;
    if (window.KKCart && typeof window.KKCart.visibleItemCount === 'function') {
      visibleCount = window.KKCart.visibleItemCount(cart);
    } else {
      visibleCount = Array.isArray(cart.items)
        ? cart.items.reduce(function (total, item) {
          var properties = item && item.properties ? item.properties : {};
          var marker = properties._kk_fast_track;
          var isFastTrack = marker === true || String(marker || '').trim().toLowerCase() === 'true';
          return isFastTrack
            ? total
            : total + (Number(item.quantity) || 0);
        }, 0)
        : cart.item_count;
    }

    toArray(document.querySelectorAll('[data-header-cart-count]')).forEach(function (count) {
      count.setAttribute('data-header-cart-count', visibleCount > 0 ? String(visibleCount) : '');
      count.classList.toggle('visible', visibleCount > 0);
    });

    toArray(document.querySelectorAll('[data-header-cart-button], .site-header-cart-button')).forEach(function (button) {
      button.classList.toggle('count-hidden', visibleCount < 1);
    });
  }

  function notifyCartUpdated(cart) {
    updateHeaderCartCount(cart);

    try {
      if (window.api && window.api.theme && typeof window.api.theme.triggerEvent === 'function') {
        window.api.theme.triggerEvent('cart:updated', { cancel: function () {} });
      }
    } catch (error) {
      // The direct cart response and KiekkoKingi cart service remain authoritative.
    }

    document.dispatchEvent(new CustomEvent('kk:cart:updated', {
      detail: { cart: cart }
    }));
  }

  function syncCartExperience(cart, trigger) {
    if (window.KKCart && typeof window.KKCart.handleExternalUpdate === 'function') {
      return window.KKCart.handleExternalUpdate(cart, {
        open: true,
        source: 'mystery-set',
        trigger: trigger || null
      }).then(function (freshCart) {
        if (typeof window.KKCart.isDrawerMode === 'function' && !window.KKCart.isDrawerMode()) {
          window.location.assign(getRoute('cart_url', 'cart'));
        }
        return freshCart;
      });
    }

    notifyCartUpdated(cart);
    return Promise.resolve(cart);
  }

  function parseError(response) {
    return response.json()
      .then(function (body) {
        return body && (body.description || body.message);
      })
      .catch(function () {
        return '';
      });
  }

  function addSelectedVariant(form, button) {
    var variant = form.querySelector('[name="id"]');
    var status = getStatus(form, button);
    var properties = getProperties(form);
    var item;

    if (!variant || !variant.value || pendingForms.has(form)) {
      return;
    }

    item = {
      id: Number(variant.value),
      quantity: getQuantity(form)
    };

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    pendingForms.add(form);
    status.hidden = true;
    status.textContent = '';
    button.classList.add('processing');
    button.disabled = true;

    fetch(getRoute('cart_add_url', 'cart/add'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return parseError(response).then(function (message) {
          throw new Error(message || 'Tuotetta ei voitu lis\u00e4t\u00e4 ostoskoriin.');
        });
      })
      .then(function () {
        return fetch(getRoute('cart_url', 'cart'), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
      .then(function (cart) {
        return cart ? syncCartExperience(cart, button) : null;
      })
      .catch(function (error) {
        status.textContent = error && error.message
          ? error.message
          : 'Tuotetta ei voitu lis\u00e4t\u00e4 ostoskoriin. Yrit\u00e4 uudelleen.';
        status.hidden = false;
      })
      .finally(function () {
        pendingForms.delete(form);
        button.classList.remove('processing');
        button.disabled = false;
      });
  }

  function getTouch(list, identifier) {
    return toArray(list).find(function (touch) {
      return touch.identifier === identifier;
    });
  }

  function handleTouchStart(event) {
    var button = event.target && event.target.closest
      ? event.target.closest(BUTTON_SELECTOR)
      : null;
    var form = getProductForm(button);
    var touch = event.changedTouches && event.changedTouches[0];

    if (!form || !touch) {
      return;
    }

    touchActivation = {
      button: button,
      form: form,
      identifier: touch.identifier,
      startX: touch.clientX,
      startY: touch.clientY,
      moved: false
    };
  }

  function handleTouchMove(event) {
    if (!touchActivation) {
      return;
    }

    var touch = getTouch(event.touches, touchActivation.identifier);

    if (
      touch &&
      (Math.abs(touch.clientX - touchActivation.startX) > 12 ||
        Math.abs(touch.clientY - touchActivation.startY) > 12)
    ) {
      touchActivation.moved = true;
    }
  }

  function handleTouchEnd(event) {
    var activation = touchActivation;
    touchActivation = null;

    if (!activation || activation.moved || !getTouch(event.changedTouches, activation.identifier)) {
      return;
    }

    var button = event.target && event.target.closest
      ? event.target.closest(BUTTON_SELECTOR)
      : null;

    if (button !== activation.button) {
      return;
    }

    lastTouchActivationAt = Date.now();

    // Easify can consume the synthesized click on this product. Capture the
    // completed tap before the app and submit the selected Shopify variant.
    if (event.cancelable) {
      event.preventDefault();
    }
    event.stopImmediatePropagation();
    addSelectedVariant(activation.form, activation.button);
  }

  function handleTouchCancel() {
    touchActivation = null;
  }

  // The dedicated button is rendered as type="button", so Easify does not
  // claim it as the form's submit control. Keep this listener narrowly scoped
  // to the Mystery Set and submit the selected native Shopify variant.
  function handleClick(event) {
    var button = event.target && event.target.closest
      ? event.target.closest(BUTTON_SELECTOR)
      : null;
    var form = getProductForm(button);

    if (!form) {
      return;
    }

    // Easify still renders the optional free-text field inside this form, but
    // the theme owns this button and the actual Shopify cart request.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (Date.now() - lastTouchActivationAt < 750) {
      return;
    }

    addSelectedVariant(form, button);
  }

  window.addEventListener('touchstart', handleTouchStart, { capture: true, passive: true });
  window.addEventListener('touchmove', handleTouchMove, { capture: true, passive: true });
  window.addEventListener('touchend', handleTouchEnd, { capture: true, passive: false });
  window.addEventListener('touchcancel', handleTouchCancel, true);
  window.addEventListener('click', handleClick, true);
}());
